import React, { useState, useRef, useEffect } from 'react';
import Transition from '@/utils/Transition';
import classNames from 'classnames';

function Tooltip({
  children,
  className,
  bg,
  size,
  position,
}) {

  const [tooltipOpen, setTooltipOpen] = useState(false);

  const buttonRef = useRef();
  const tooltipRef = useRef();
  const tooltipTriangleRef = useRef();

  const positionOuterClasses = (position) => {
    switch (position) {
      case 'right':
        return 'left-full top-1/2 -translate-y-1/2';
      case 'left':
        return 'right-full top-1/2 -translate-y-1/2';
      case 'bottom':
        return 'top-full left-1/2 -translate-x-1/2';
      default:
        return 'bottom-full left-1/2 -translate-x-1/2';
    }
  }

  const sizeClasses = (size) => {
    switch (size) {
      case 'lg':
        return 'min-w-72 pt-1.5 pb-2.5 pl-2.5 pr-3.5';
      case 'md':
        return 'min-w-56 pt-1.5 pb-2.5 pl-2.5 pr-3.5';
      case 'sm':
        return 'min-w-44 pt-1.5 pb-2.5 pl-2.5 pr-3.5';
      default:
        return 'p-2';
    }
  };

  const positionInnerClasses = (position) => {
    switch (position) {
      case 'right':
        return 'ml-1';
      case 'left':
        return 'mr-1';
      case 'bottom':
        return 'mt-1';
      default:
        return 'mb-1';
    }
  };

  useEffect(() => {
    if (tooltipOpen) {
      handleTooltipPosition();
    }
  }, [tooltipOpen]);

  const handleTooltipPosition = () => { // fixing tooltip position if it goes out of screen
    const screenPadding = 15;

    const buttonRect = buttonRef.current.getBoundingClientRect();
    const tooltipRect = tooltipRef.current.getBoundingClientRect();

    const tooltipRightX = tooltipRect.x + tooltipRect.width;
    const buttonRightX = buttonRect.x + buttonRect.width;

    if (tooltipRect.x < 0) {
      tooltipRef.current.style.left = '0';
      tooltipRef.current.style.right = 'auto';
      tooltipRef.current.style.transform = `translateX(${-buttonRect.x + screenPadding}px)`;
      tooltipTriangleRef.current.style.marginLeft = `${buttonRect.x - screenPadding}px`;
    } else if (tooltipRightX > window.screen.width) {
      tooltipRef.current.style.left = 'auto';
      tooltipRef.current.style.right = '0';
      tooltipRef.current.style.transform = `translateX(${(window.screen.width - buttonRightX) - screenPadding}px)`;
      tooltipTriangleRef.current.style.marginRight = `${(window.screen.width - buttonRightX) - screenPadding}px`;
    }
  };

  return (
    <div
      className={`relative ${className}`}
      onMouseEnter={() => setTooltipOpen(true)}
      onMouseLeave={() => setTooltipOpen(false)}
      onFocus={() => setTooltipOpen(true)}
      onBlur={() => setTooltipOpen(false)}
    >
      <button
        ref={buttonRef}
        className="w-3 h-3 md:w-4 md:h-4 flex items-center justify-center rounded-full"
        aria-haspopup="true"
        aria-expanded={tooltipOpen}
        onClick={(e) => e.preventDefault()}
        style={{ backgroundColor: 'currentColor' }}
      >
        <svg className="fill-current" width="4" height="10" viewBox="0 0 4 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="2" cy="1.5918" r="1.21973" fill="white" />
          <rect x="1.10303" y="4.24707" width="1.79372" height="5.38117" fill="white" />
        </svg>
      </button>
      <div ref={tooltipRef} className={`z-10 absolute ${positionOuterClasses(position)}`}>
        <Transition
          show={tooltipOpen}
          tag="div"
          className={`relative rounded-lg ${bg === 'dark' ? 'bg-[#1A1C1D] text-white' : 'bg-brand-green text-brand-white '} ${sizeClasses(size)} ${positionInnerClasses(position)}`}
          enter="transition ease-out duration-200 transform"
          enterStart="opacity-0 -translate-y-2"
          enterEnd="opacity-100 translate-y-0"
          leave="transition ease-out duration-200"
          leaveStart="opacity-100"
          leaveEnd="opacity-0"
        >
          {/*<div ref={tooltipTriangleRef} className={classNames(*/}
          {/*  'absolute z-1 left-0 right-0 bottom-[-8px] top-auto mx-auto w-0 h-0 border-l-[7px] border-l-transparent border-t-[8px] border-r-[7px] border-r-transparent',*/}
          {/*  bg === 'dark' ? 'border-t-[#1A1C1D]' : 'border-t-brand-green',*/}
          {/*)} />*/}
          {children}
        </Transition>
      </div>
    </div>
  );
}

export default Tooltip;
